<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            fullscreen
            content-class="d-flex justify-center align-center"
        >
            <div
                class="d-flex flex-column justify-center align-center elevation-15 result-content border-radius-2"
            >
                <div class="d-flex flex-column justify-center align-center position-relative">
                    <div class="pa-5 mx-5 d-flex justify-center align-center flex-column">
                        <div>
                            <span class="text-subtitle-1 primary--text pa-5 font-weight-lighter">
                                {{ $t('challenge.result') }}
                            </span>
                        </div>
                        <div>
                            <span class="text-h4 primary--text pa-5 font-weight-lighter">
                                {{ $t('challenge.very_well_done') }}
                            </span>
                        </div>
                    </div>
                    <div class="px-5 mx-5">
                        <div class="d-flex justify-center flex-row align-center pa-5">
                            <SuperStar :content="count_corrects" />
                        </div>
                        <div
                            class="px-5 py-3 mx-5 d-flex align-center justify-center border-radius-2 result-msg-content"
                        >
                            <span class="primary--text text-body-1">
                                {{ result_msg }}
                            </span>
                        </div>
                    </div>
                    <v-card-actions class="d-flex justify-center align-center ma-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="resultMsgModal-finish-by-correct-answers-button"
                            color="secondary"
                            class="px-10 py-5"
                            rounded
                            @click="collectPrize"
                            v-if="count_corrects >= 4 && !finish"
                        >
                            {{ $t('challenge.collect_prize') }}
                        </v-btn>
                        <v-btn
                            data-cy="resultMsgModal-try-again-button"
                            color="secondary"
                            class="px-5 py-5"
                            rounded
                            @click="tryAgain"
                            v-if="count_corrects < 4 && !finish"
                        >
                            {{ $t('bookReading.try_again') }}
                        </v-btn>
                        <v-btn
                            data-cy="resultMsgModal-finish-button"
                            color="secondary"
                            class="px-5 py-5"
                            rounded
                            @click="finishAction"
                            v-if="finish"
                        >
                            {{ $t('initialTour.finish') }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </div>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */

import SuperStar from '@/components/core/SuperStar.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_corrects: { type: [String, Number], default: 0 },
        finish: { type: Boolean, default: false },
    },
    components: {
        SuperStar,
    },
    data() {
        return {
            varitaImg: require('@/assets/img/icons/beecoins-1.svg'),
            absolute: true,
        }
    },
    methods: {
        collectPrize() {
            this.$emit('collect-prize')
        },
        tryAgain() {
            this.$emit('try-again')
        },
        finishAction() {
            this.$emit('finish-action')
        },
    },
    computed: {
        result_msg() {
            switch (this.count_corrects) {
                case 4:
                case '4':
                    return this.$t('challenge.result_msg_1')
                case 3:
                case '3':
                    return this.$t('challenge.result_msg_2')
                case 2:
                case '2':
                    return this.$t('challenge.result_msg_3')
                case 1:
                case '1':
                    return this.$t('challenge.result_msg_4')
                default:
                    return this.$t('challenge.result_msg_0')
            }
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.result-content {
    width: 35%;
    box-sizing: border-box;
    border: 2px solid #4bada1;
    background: radial-gradient(circle, #f4f9f9 0%, #ceecea 100%);
    box-shadow: -7px 6px 12px 5px rgba(0, 0, 0, 0.07);
}

.items-unset {
    align-items: unset !important;
}

.bright-points {
    align-items: center;
    color: #816ad6;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}
.bee-icon-size {
    width: 16.5vh;
}
.bee-icon-size-2 {
    width: 17.5vh;
}
.z-text {
    z-index: 10;
}
.result-msg-content {
    background-color: #d5efee;
    font-weight: bold !important;
}
</style>
